export default "__VITE_ASSET__DarypVXZ__"